<script setup lang="ts">
import { computed, ref } from "vue";
import { useTypeDetection } from "~/features/python/ch2/data-types/composables/useTypeDetection";

const value = ref("hello");
const { detectType } = useTypeDetection();

const detected = computed(() => detectType(value.value));
const applySample = (sample: string) => {
  value.value = sample;
};
</script>

<template>
  <article class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Python is cheez ko kya samajhta hai?</h2>
      <p class="text-sm text-slate-600">Koi value likho. Hum batayenge ke Python usay number, text ya kuch aur samajhta hai.</p>
    </div>

    <label class="block space-y-2">
      <span class="text-sm font-medium text-slate-700">Yahan likho</span>
      <input
        v-model="value"
        type="text"
        class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400"
      >
    </label>

    <div class="flex flex-wrap gap-2">
      <button
        v-for="sample in ['hello', '5', '5.2', 'True']"
        :key="sample"
        type="button"
        class="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-medium text-slate-700"
        @click="applySample(sample)"
      >
        {{ sample }}
      </button>
    </div>

    <div class="rounded-2xl bg-sky-50 p-4 ring-1 ring-sky-100">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Python ka jawab</p>
      <p class="mt-1 text-lg font-bold text-slate-900">{{ detected.label }}</p>
      <p class="mt-1 text-sm text-slate-700">{{ detected.explanation }}</p>
    </div>
  </article>
</template>
